module.exports = __webpack_public_path__ + "img/Invasion-PRCA_10X_AIC.7dfe0663.png";